import React from 'react';
import { Button } from '@3plearning/react-components';
import propTypes from 'prop-types';
import { t } from '@lingui/macro';
import { useSelector, useDispatch } from 'react-redux';
import {
  UnassignModalOuter,
  UnassignModalInner
} from './unassign-all-modal.styled';
import Resources from '../../helpers/resources';
import { getTopics } from '../../containers/course-assign/course-assign-actions';
import { showToast } from '../toast/toast-action';
import { ERROR_DETECTED } from '../../containers/course-assign/course-assign-types';
import { HIDE_UNASSIGN_MODAL } from './store/unassign-all-modal.actions';

function UnassignAllModal(props) {
  const { i18n } = props;
  const isOpen = useSelector(
    (state) => state.unassignModalReducer.isUnassignModalOpen
  );
  const dispatch = useDispatch();
  const classroomId = useSelector(
    (state) => state.CourseAssignReducer.activeClass
  );
  const groupId = useSelector((state) => state.CourseAssignReducer.activeGroup);

  function handleSuccess() {
    dispatch(getTopics(classroomId, groupId));
    dispatch(
      showToast(
        i18n._(
          t(
            'footer.assignSuccess'
          )`Selected student activities have been assigned`
        ),
        'success'
      )
    );
    dispatch({
      type: HIDE_UNASSIGN_MODAL
    });
  }

  function handleUnassignAll() {
    Resources.unassignAll
      .put({ classroomId, groupId })
      .withBody({})
      .send()
      .then(
        () => {
          handleSuccess();
          dispatch(
            showToast(
              i18n._(
                t(
                  'footer.unassignAllSuccess'
                )`all student activities in this class group have been unassigned`
              ),
              'success'
            )
          );
        },
        (err) => {
          dispatch({
            type: ERROR_DETECTED,
            payload: err
          });
        }
      );
  }

  return (
    <>
      {isOpen ? (
        <UnassignModalOuter data-testid="unassign-modal">
          <UnassignModalInner>
            <h2>{i18n._(t('footer.unassignAllModalHeader')`Unassign all?`)}</h2>
            <p>
              {i18n._(t('footer.unassignAllModalText')`All activities assigned
              to any students in this group will be unassigned. Do you wish to
              continue?`)}
            </p>
            <Button
              text={i18n._(t('generic')`cancel`)}
              secondary
              type={Button.LOZENGE}
              onClick={() => dispatch({ type: HIDE_UNASSIGN_MODAL })}
            />
            <Button
              text={i18n._(t('generic.submit')`submit`)}
              primary
              type={Button.LOZENGE}
              onClick={() => handleUnassignAll()}
            />
          </UnassignModalInner>
        </UnassignModalOuter>
      ) : null}
    </>
  );
}
UnassignAllModal.propTypes = {
  i18n: propTypes.object
};

export default UnassignAllModal;



// WEBPACK FOOTER //
// ./components/unassign-all-modal/unassign-all-modal.js